import { Link } from 'gatsby';
import React from 'react';
import moment from 'moment';
import classNames from 'classnames';

export class EventTile extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  get image () {
    const dimensions = '?w=960&h=740&fm=jpg&fit=fill';
    if (!this.props.headerImages || this.props.headerImages.length === 0) return false;
    return this.props.headerImages[0].image?.file?.url + dimensions;
  }

  get date () {
    if (!(this.props.eventSchedule && this.props.eventSchedule.length > 0)) return '';
    let first = this.props.eventSchedule[0].schedule?.length > 0 ? this.props.eventSchedule[0].schedule[0] : false;
    if (!first) return '';

    if (!first.endDate) return moment(first.startDate).format('DD.MM');

    return [
      moment(first.startDate).format('DD.MM'),
      moment(first.endDate).format('DD.MM')
    ].join(' - ')
  }

  render () {
    const className = classNames({
      'event-tile': true,
      'event-tile--passed': this.props.hasPassed
    })

    return (
      <Link to={this.props.slug} className={className} id={this.props.id}>
        <div className="event-tile__top">
          <div className="event-tile__image">
            <img src={this.image} alt={this.props.longTitle} />
          </div>
          <div className="event-tile__excerpt">
            <div className="event-tile__excerpt__text">
              { this.props.excerpt }
            </div>
          </div>
        </div>
        <div className="event-tile__bottom">
          <div className="event-tile__bottom__festival">
            { this.props.festival.title }
          </div>
          <div className="event-tile__bottom__content">
            { this.date }<br/>
            { this.props.longTitle }
          </div>
          <div className="event-tile__bottom__categories">
            { this.props.categories.map(category => <span>{ category.title }</span>) }
          </div>
        </div>
      </Link>
    );
  }
}
